/*
 * Filename: utility.ts
 * Description:Connects our app to salesforce
 */

interface IFields {
    fieldFullName: string,
    fieldLabel: string,
    fieldType: string,
    referenceTo: string | string[],
    relationshipName: string
}

export class Utility {

    /**
     * @memberof Utility
     */
    public titleCase = (str: any) => {
        if (str) {
            var splitStr = str.toLowerCase().split(' ');
            for (var i = 0; i < splitStr.length; i++) {
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
            }
            return splitStr.join(' ');
        }
        return '';
    }

    public getStoreName(templateName:string = '') {
        if(templateName.includes('cqEsig') && !templateName.includes('cqEsigAction')){
            return 'cqEsig';
        }else if(templateName.includes('cqEsigAction')){
            return 'cqEsigAction';
        }else if(templateName.includes('cqForm')){
            return 'cqForm';
        }else if(templateName.includes('cqGridGenerator')){
            return 'cqGridGenerator';
        }else {
            // if non of the case is true than cqTemplate
            return templateName;
        }
    }

    createObjectDeepCopy<T>(sourceObject: T): T {
        if(sourceObject) {
            return JSON.parse(JSON.stringify(sourceObject));
        }

        return sourceObject;
    }

    public toPascalCase = (stringVal: string) => {
        stringVal = `${stringVal}`.replace(/__/g,'_');
        const names = `${stringVal}`.split('_').map((part: string) => {
          return part === 'SQX' || part === 'CQ' || part === 'compliancequest' || part === 'c' ? '' : part.substr(0, 1).toUpperCase() + part.substr(1).toLowerCase();
        });
        return names.join('');
    }

    public toKebabStyle = (stringVal: string) => {
        return stringVal.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
    }

    public toCamelCase = (str: string) => {
        return str
            .replace(/\s(.)/g, function ($1) { return $1.toUpperCase(); })
            .replace(/\s/g, '')
            .replace(/^(.)/, function ($1) { return $1.toLowerCase(); });
    }

    /**
     *
     * camelize
     * @param {string} name
     * @returns
     */
    camelize(name: string) {
        return this._stripUnderscoresAndNamespace(name);
    }

    /**
     *
     * stripUnderscoresAndNamespace
     * @param {string} name
     * @returns
     */
    _stripUnderscoresAndNamespace(name: string) {
        let pattern = /^\w+_(\w+)__c/;
        let returnVal = name;

        if(name && name.match(pattern)){
        returnVal = this._stripSQXOrCQAndUnderscores(name.match(pattern)![0]);
        }

        pattern = /^\w+__(\w+)__c$/;
        if (name && name.match(pattern)) {
        returnVal = this._stripSQXOrCQAndUnderscores(name.match(pattern)![1]);
        }
        return returnVal;
    }

    /**
     *
     * stripSQXAndUnderscores
     * @param {string} name
     * @returns
     */
    _stripSQXOrCQAndUnderscores(name: string) {
        const names = name.split('_').map((part: string) => {
        return part === 'SQX' || part === 'CQ' ? '' : part.substr(0, 1).toUpperCase() + part.substr(1).toLowerCase();
        });
        if(names[names.length - 1] === 'C'){
        names.pop();
        }
        return names.join('');
    }

    /**
     * Generates the label from the object-api-name
     * @param objectApiName apiName of the selected object
     */
    public generateLabel = (objectApiName: string): string => {
        objectApiName = objectApiName.replace(/__/g,'_');
        const generatedLabel = objectApiName.split('_').map((part: string) => {
            return part === 'SQX' || part === 'CQ' || part === 'compliancequest' || part === 'c' ? '' : part.substr(0, 1).toUpperCase() + part.substr(1).toLowerCase();
        });

        return generatedLabel.join(' ').trim();
    }

    /**
     * generated class name based on the size
     * @param { number } size how much space does the component want to cover in 12 column layout
     * @returns { string } class name for the given size
     */
    public getColumnClassName = (size?: number) => {
        let className = "slds-col";

        switch(size) {
            case 6:
                className += " slds-size_6-of-12";
                break;

            default:
                className += "  slds-size_12-of-12";
        }

        return className;
    }
    
    /**
     * maps layout fields or object fields and return only required property
     * @param fields layout fields or object fields array
     * @param cb Used to map field with subheading
     * @returns fields with required property 
     */
     public mapField = (fields: any[], cb?: (field: any) => {}): IFields[] => (
        fields.map((field: any) => {
            let cbResult = {};

            if(cb && typeof cb === 'function') {
                cbResult = cb(field);
            }

            return {
                ...cbResult,
                fieldFullName: field.name || field.fieldFullName,
                fieldLabel: field.label || field.fieldLabel,
                fieldType: field.type || field.fieldType,
                referenceTo: field.referenceTo,
                relationshipName: field.relationshipName
            }
        })
    )
}
